module.exports = __webpack_public_path__ + "static/6326-0eba09137f197083b0a87b5e0f21ac95.png";